// @flow
import React, { type Node, Fragment } from 'react';

import type { OrderItemMap } from 'app/common/components/Cafeteria/dataTypes/order/OrderItem.types';
import PlainList from 'app/common/ui-next/plain-list';

import EmptyOrder from '../../../../commonComponents/EmptyOrder';
import OrderItem from '../../../../commonComponents/OrderItem';

import styles from './OrderForm.module.scss';;


type Props = {
  disabled?: boolean,
  pending: boolean,
  orderItems: OrderItemMap,
  currency: string,
  onCountIncrement: (id: string) => void,
  onCountDecrement: (id: string) => void,
  onRemove: (id: string) => void,
}

const OrderForm = ({
  disabled,
  pending: externalPending,
  orderItems,
  currency,
  onCountIncrement,
  onCountDecrement,
  onRemove,
}: Props): Node => {
  const empty = orderItems.size === 0;

  return (
    <Fragment>
      {empty
        && <EmptyOrder
          className={styles.emptyRoot}
          loading={externalPending}
        />}

      {!empty
        && <PlainList id="order" autoHeight={false} scrollPadding={false}>
          {Array.from(orderItems.values()).map(({ id, title, cost, amount, freeCount, incrementEnabled }) => (
            <OrderItem
              className={styles.orderItem}
              key={id}
              guid={id}
              title={title}
              cost={cost * amount - cost * freeCount}
              n={amount}
              type="complex"
              portion="" // no portion in complex
              incDisabled={!incrementEnabled}
              locked={disabled}
              currency={currency}
              onCountIncrement={onCountIncrement}
              onCountDecrement={onCountDecrement}
              onRemove={onRemove}
            />
          ))}
        </PlainList>}
    </Fragment>
  );
};

export default OrderForm;
